import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  window.addEventListener('storage', onChange);
  return () => window.removeEventListener('storage', onChange);
};

const getSnapshot = () => localStorage.getItem('isViewing') === 'true';

const getServerSnapshot = () => false;

export const useIsViewing = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
